import { flatten } from 'lodash';
import { Layout, LayoutKey } from '../types';

export function flattenLayoutToSet(layout: Layout): Set<LayoutKey> {
	return new Set(flatten(layout));
}
